var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-sheet',{staticClass:"py-2 px-5"},[_c('VehiclesField',{model:{value:(_vm.vehicles),callback:function ($$v) {_vm.vehicles=$$v},expression:"vehicles"}}),_c('PeriodField',{attrs:{"periods":_vm.periods},model:{value:(_vm.period),callback:function ($$v) {_vm.period=$$v},expression:"period"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }